module.exports = __webpack_public_path__ + "img/badge-highest-revenue-gold.794599c0.png";